/* Fine Foams newsletter signup → Klaviyo.

   Progressive enhancement over the Shopify {% form 'customer' %} in
   ff-signup.liquid. If the company id or list id is missing, or anything here
   throws, we simply never call preventDefault() and the native Shopify form
   posts as it always did — a broken Klaviyo config must not cost a subscriber.

   Endpoint: POST /client/subscriptions (Klaviyo's public, browser-safe client
   API — it takes the PUBLIC api key, never a private one). Returns 202 with an
   empty body on success. Double opt-in vs single is a property of the Klaviyo
   list itself, not of this request. */
(function () {
  var REVISION = '2026-07-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';

  function init(section) {
    var company = (section.getAttribute('data-ff-klaviyo-company') || '').trim();
    var listId = (section.getAttribute('data-ff-klaviyo-list') || '').trim();
    // Not configured → leave the native Shopify form completely alone.
    if (!company || !listId) return;

    var form = section.querySelector('form');
    var email = section.querySelector('input[type="email"]');
    var button = section.querySelector('button[type="submit"]');
    var status = section.querySelector('[data-ff-signup-status]');
    if (!form || !email || !button || !status) return;

    var source = section.getAttribute('data-ff-klaviyo-source') || 'Homepage signup';
    var successText = section.getAttribute('data-ff-success-text') || "You're subscribed";
    var errorText =
      section.getAttribute('data-ff-error-text') || "That didn't go through. Please try again.";
    var busy = false;

    function say(message, state) {
      status.textContent = message;
      status.setAttribute('data-state', state);
      status.hidden = false;
    }

    function setBusy(on) {
      busy = on;
      button.setAttribute('aria-busy', on ? 'true' : 'false');
      button.disabled = on;
    }

    form.addEventListener('submit', function (event) {
      // Let the browser's own required/type=email validation speak first.
      if (!email.value || (form.checkValidity && !form.checkValidity())) return;
      if (busy) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      setBusy(true);
      status.hidden = true;
      status.removeAttribute('data-state');

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo responded ' + response.status);

          // Tie this browser to the profile so Klaviyo can attribute later
          // browsing and abandoned carts to the person who just signed up.
          try {
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
              window.klaviyo.identify({ email: email.value.trim() });
            }
          } catch (e) {
            /* identify is a nice-to-have; never let it break the success path */
          }

          email.hidden = true;
          button.hidden = true;
          say(successText, 'success');
          status.focus();
        })
        .catch(function (error) {
          if (window.console && console.warn) console.warn('[ff-signup]', error);
          say(errorText, 'error');
          setBusy(false);
        });
    });
  }

  function boot() {
    var sections = document.querySelectorAll('[data-ff-signup]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-bind when the section is re-rendered after a setting change.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-ff-signup]')
      : null;
    if (section) init(section);
  });
})();
